import React from 'react';
import { Box, Typography } from '@mui/material';
import { useFormContext } from 'react-hook-form';
import { transformSeals } from '../../../../../utils';

const PumpOffSealDisplay = ({ name }) => {
    const { getValues } = useFormContext();

    const seals = getValues(name);

    return (
        <Box sx={{ border: '1px solid #E0E0E0', borderRadius: 1, p: 2 }}>
            <Typography sx={{ mb: 1 }} variant="h6">
                Seals
            </Typography>
            <Box>
                {seals?.map((seal, index) => (
                    <Typography variant="body1" key={`${index + 1}-${seal.barcode}`}>
                        {transformSeals(seal.seal_type)} - {seal.barcode}
                    </Typography>
                ))}
            </Box>
        </Box>
    );
};

export default PumpOffSealDisplay;
